import { useCallback } from "react";

const useImageUrlModifier = () => {
  const modifyImageUrl = useCallback((
    url: string,
    width: number = 400,
    height: number = 400,
    isVideo = false
  ): string | null => {
    if (!url) return null;
    try {
      const parsedUrl = new URL(url);

      // Ensure the domain matches the required domain
      if (parsedUrl.hostname === "static.mypaydo.com") {
        // Modify the URL according to the requirements
        let modifiedUrl = ``;
        if (isVideo) {
          modifiedUrl = url;
        } else {
          modifiedUrl = `https://cdn.mypaydo.com/${width}x${height}/filters:format(webp)${parsedUrl.pathname}`;
        }
        return modifiedUrl;
      }

      else if (parsedUrl.hostname === "res.cloudinary.com") {
        // Modify the URL for res.cloudinary.com
        const isImageURL = parsedUrl.pathname?.startsWith("/ddhnex96c/image/upload/");
        const isVideoURL = parsedUrl.pathname?.startsWith("/ddhnex96c/video/upload/");
        let modifiedUrl = ``;
        if (isImageURL) {
          const cloudinaryPath = parsedUrl.pathname?.split("/ddhnex96c/image/upload/")?.at(-1);
          modifiedUrl = `https://res.cloudinary.com/ddhnex96c/image/upload/w_${width},h_${height},c_fill/${cloudinaryPath}`;
        }
        else if (isVideo || isVideoURL) {
          modifiedUrl = url?.replace(
            /^https:\/\/res\.cloudinary\.com/,
            "https://res.cloudinary.com"
          );
        }
        return modifiedUrl;
      }
      // If no matching domain, return the original URL
      return url;
    } catch {
      return url;
    }
  }, []);

  return modifyImageUrl;
};

export default useImageUrlModifier;
